import { render } from "./Patents.vue?vue&type=template&id=b649c9c8&scoped=true"
import script from "./Patents.vue?vue&type=script&lang=js"
export * from "./Patents.vue?vue&type=script&lang=js"

import "./Patents.vue?vue&type=style&index=0&id=b649c9c8&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3442\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b649c9c8"]])

export default __exports__